import { Button } from '@askable/ui/core/button';
import { Link } from '@askable/ui/core/link';
import { showMessages } from '@intercom/messenger-js-sdk';
import { useTranslation, Trans } from 'react-i18next';

const Error = ({
  title,
  message,
  showHomeLink,
  showRefreshLink = true,
  linkTo,
  children,
}: {
  title?: string;
  message?: string;
  showHomeLink?: boolean;
  showRefreshLink?: boolean;
  linkTo?: string;
  children?: React.ReactNode;
}) => {
  const { t } = useTranslation();
  const reset = () => window.location.reload();
  return (
    <div className="flex h-full w-full items-center justify-center">
      <div className="max-w-1/2">
        <div className="flex flex-col items-center gap-6">
          <div className="flex flex-col items-start gap-4 md:items-center md:text-center">
            <h1 id="heading" className="text-2xl font-semibold">
              {title ?? t('errors.default')}
            </h1>
            <p className="max-w-96 text-center text-md text-foreground">
              {message ?? (
                <Trans i18nKey="errors.defaultInstructions">
                  Please try refreshing and joining the call again. If the issue persists, please
                  <Button className="inline-flex p-0 text-md" variant="link" onClick={() => showMessages()}>
                    contact support
                  </Button>
                  .
                </Trans>
              )}
            </p>
            {children}
          </div>
          {showHomeLink ? <Link href={linkTo ?? '/'}>{t('global.returnHome')}</Link> : null}
          {showRefreshLink ? (
            <Button variant="primary" onClick={() => reset()}>
              {t('global.refresh')}
            </Button>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default Error;
